'use client';

import { FileTree } from './components/FileTree';
import _styles from './DocumentsTree.module.css';
import { DocumentsContext } from '@/_contexts/DocumentsProvider';
import { Flex, Text, Shimmer } from '@/_components';
import { useContext, useMemo } from 'react';
import type { DocumentsTreeProps } from './DocumentsTree.types';
import type { DirectoryType } from '@/_types/models/documents';

export const DocumentsTree: React.FC<DocumentsTreeProps> = ({ isPreview }) => {
  const { rootDirectories, isLoading } = useContext(DocumentsContext);
  const isEmpty: boolean = !rootDirectories?.length;

  const normalizedDirectories: Array<DirectoryType> = useMemo(
    () =>
      isPreview
        ? rootDirectories?.filter((dir) => !dir.name?.includes('STAFF ONLY')) ||
          []
        : rootDirectories || [],
    [rootDirectories, isPreview],
  );

  // State: Loading
  if (isLoading) {
    return (
      <Flex padding={6} isCentered={true} isColumn={true} gap={2}>
        <Shimmer
          width={100}
          isFullWidth={true}
          height={32}
          paddingTop={4}
          paddingBottom={4}
        />
        <Shimmer
          width={100}
          isFullWidth={true}
          height={32}
          paddingTop={4}
          paddingBottom={4}
        />
        <Shimmer
          width={100}
          isFullWidth={true}
          height={32}
          paddingTop={4}
          paddingBottom={4}
        />
      </Flex>
    );
  }

  // State: Empty
  if (isEmpty) {
    return (
      <Flex padding={6}>
        <Text type="small" color="secondary">
          There are no files in this folder.
        </Text>
      </Flex>
    );
  }

  return (
    <Flex isColumn={true} padding={4}>
      <ol>
        {normalizedDirectories
          ?.filter((d) => d.type === 'folder')
          ?.map((item, key) => {
            return <FileTree key={key} documentItem={item} />;
          })}
      </ol>
    </Flex>
  );
};
